import { Wallet } from "lucide-react";
import { NodeCategory, registerNode } from "../../lib/register-node";
import { WalletNotificationActionNodeEditor } from "./editor";
import { WalletNotificationActionNodePanel } from "./panel";
import { WalletNotificationActionNodeProps } from "./types";
import {
  ActionNodeDataDto,
  ActionNodeWalletNotificationConfigDto,
} from "@babackapp/private-api-client/types";

type WalletNotificationConfigWithContent =
  ActionNodeWalletNotificationConfigDto & {
    titleContent?: { [key: string]: string };
    textContent?: { [key: string]: string };
  };

const newNodeDefaultConfig: WalletNotificationConfigWithContent = {
  titleContent: {},
  textContent: {},
  sendNotification: true,
  overrides: null,
};

const newNodeDefaultValue: ActionNodeDataDto = {
  actionType: "send_wallet_notification",
  config: newNodeDefaultConfig,
};

export default registerNode<WalletNotificationActionNodeProps["data"]>({
  type: "action:send_wallet_notification",
  name: "workflowsEditor.nodes.sendWallet.title",
  description: "workflowsEditor.nodes.sendWallet.description",
  Icon: Wallet,
  category: NodeCategory.ACTION,
  color: "green",
  editor: {
    component: WalletNotificationActionNodeEditor,
  },
  configPanel: {
    component: WalletNotificationActionNodePanel,
  },
  newNodeDefaultData: newNodeDefaultValue,
});

export * from "./types";
export { WalletNotificationActionNodeEditor } from "./editor";
export { WalletNotificationActionNodePanel } from "./panel";
export * from "./default-translations";
